import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * Servicio simple para obtener el storage correcto según configuración
 */
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public static checkStorage(): Storage {
    return environment.useSessionStorage === true ? sessionStorage : localStorage;
  }
}
